import tpl from "./template.ejs";

/**
 * Модальное окно
 */
export default class ModalWindow {

    /**
     * options:
     *   content - содержимое окна (строка, элемент, jQuery или функция)
     *   onClose - функция, которая вызывается перед закрытием окна. если вернёт false, окно не закроется
     *
     * @param options
     */
    constructor(options) {
        Object.assign(this, options);
        this.render();
    }

    render() {
        this.$el = $("<div>").html(tpl())
            .find('.mw-content').append(this.content).end()
            .appendTo(document.body).click(::this.onClick);

        this.el = this.$el[0];
    }

    close() {
        if (typeof this.onClose != "function" || this.onClose()) {
            this.el.remove();
        }
    }

    onClick(e) {
        if ($(e.target).hasClass("mw-overlay")) {
            this.close();
        }
    }
}
